import { TextField } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { pilotPlanes } from '../../commons/utils';
import { generalMuiForm } from '../../commons/styles';


const useStyles = makeStyles((theme) => ({
    input: {
        marginBottom: theme.spacing(1.6),
        marginTop: theme.spacing(1.6),
        width: '100%',
        ...generalMuiForm,
    },
}));


const PersonalData = ({ clientPersonalData, selectedCountry }) => {
    const classes = useStyles();

    return (
        <div className="row">
            <div className="col-12">
                <span className="text-4 text-weight-form">Información Básica de la Empresa</span>
                <br />
                <span className="text-4 text-size-2">Esta es la información ingresada para solicitar tu piloto.</span>
                <br /> <br />
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                <TextField
                    id="outlined-basic"
                    label="Empresa"
                    variant="outlined"
                    disabled
                    size="small"
                    value={clientPersonalData.company_real_name}
                    margin="dense"
                    className={classes.input}
                    InputProps={{ readOnly: true }}
                />
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                <TextField
                    id="outlined-basic"
                    label="País"
                    variant="outlined"
                    disabled
                    size="small"
                    value={(selectedCountry || {}).country}
                    margin="dense"
                    className={classes.input}
                    InputProps={{ readOnly: true }}
                />
            </div>
            <div className="col-lg-2 col-md-4 col-sm-4 col-xs-12">
                <TextField
                    id="outlined-basic"
                    label="Contacto clave"
                    variant="outlined"
                    disabled
                    size="small"
                    value={`${clientPersonalData.contact} ${clientPersonalData.contact_last_name}`}
                    margin="dense"
                    className={classes.input}
                    InputProps={{ readOnly: true }}
                />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                <TextField
                    id="outlined-basic"
                    label="Correo electrónico"
                    variant="outlined"
                    disabled
                    size="small"
                    value={clientPersonalData.email}
                    margin="dense"
                    className={classes.input}
                    InputProps={{ readOnly: true }}
                />
            </div>
            {clientPersonalData.pilot_plan && <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                <TextField
                    id="outlined-basic"
                    label="Versión a pilotear"
                    variant="outlined"
                    disabled
                    size="small"
                    value={pilotPlanes.find((p) => p.value === clientPersonalData.pilot_plan).key}
                    margin="dense"
                    className={classes.input}
                    InputProps={{ readOnly: true }}
                />
            </div>}
            {clientPersonalData.phone_number
                ? (<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <TextField
                        id="outlined-basic"
                        label="Teléfono"
                        variant="outlined"
                        disabled
                        size="small"
                        value={clientPersonalData.phone_number}
                        margin="dense"
                        className={classes.input}
                        InputProps={{ readOnly: true }}
                    />
                </div>)
                : ''}
        </div>
    );
};

export default PersonalData;
